var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('a',_vm._g(_vm._b({staticClass:"ml-2",attrs:{"href":_vm.fullUrl,"target":"_blank","rel":"noopener noreferrer"}},'a',attrs,false),on),[_c('v-btn',{attrs:{"color":"primary","text":"","icon":""}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v(" mdi-information ")])],1)],1)]}}])},[_vm._v(" View documentation ")])}
var staticRenderFns = []

export { render, staticRenderFns }